import React, { useState } from 'react';
import { Input } from 'antd';

import { getAllBookFromGoogle } from '../../../service/book';
import FormItem from 'antd/es/form/FormItem';

const { Search } = Input;

const BookElectionSearch = ({ selectedBook, setBooksSearchResults }) => {
  return (
    <FormItem
      rules={[
        {
          required: true,
          message: 'Por favor, escolha um livro'
        }]
      }>
      {!selectedBook ? (
        <Search
          style={{ width: '80%' }}
          placeholder={selectedBook?.name || "Pesquisar livro"}
          allowClear
          size="large"
          onSearch={async value => {
            const books = await getAllBookFromGoogle(value)
            setBooksSearchResults(prev => books)
          }}
        />
        ) : <Input value={selectedBook?.name} />
      }
    </FormItem>
  )
}

export default BookElectionSearch;